import React from 'react';
import { Grid, Layout } from 'lucide-react';
import { useViewMode } from '../context/ViewModeContext';

export function ViewModeToggle() {
  const { viewMode, toggleViewMode } = useViewMode();

  return (
    <div className="flex items-center justify-center space-x-2">
      <button
        onClick={toggleViewMode}
        className="flex items-center gap-2 px-3 py-2 bg-white shadow-md rounded-md hover:bg-gray-50 
                 border border-gray-200 transition-all text-sm font-medium"
        aria-label={`Switch to ${viewMode === 'compact' ? 'expanded' : 'compact'} view`}
      >
        {viewMode === 'compact' ? (
          <>
            <Layout size={16} className="text-[#A3C1DA]" />
            <span>Expanderad vy</span>
          </>
        ) : (
          <>
            <Grid size={16} className="text-[#A3C1DA]" />
            <span>Kompakt vy</span>
          </>
        )}
      </button>
      <span className="text-xs text-gray-500">
        {viewMode === 'compact' 
          ? 'Visa grundläggande information' 
          : 'Visa all information'}
      </span>
    </div>
  );
}
